import { Channel } from '@/app/store/api/restApi';

export interface LaunchAttribution {
  channel: Channel;
  utmCampaignId?: string;
}

/** Reads the mini-app launch parameter (Telegram or web) from the current URL. */
export const getLaunchParam = (): string | null => {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  return params.get('tgWebAppStartParam') ?? params.get('startapp');
};

export const parseLaunchAttribution = (startParam: string | null): LaunchAttribution => {
  if (!startParam) return { channel: Channel.Organic };

  if (startParam.startsWith('utm_')) {
    const utmCampaignId = startParam.split('_')[1];
    return utmCampaignId ? { channel: Channel.Utm, utmCampaignId } : { channel: Channel.Organic };
  }

  if (startParam.startsWith('promo_')) {
    return { channel: Channel.Promo };
  }

  return { channel: Channel.Organic };
};

/** Fields to spread into an events/order/login body. Omits both when organic. */
export const buildAttributionFields = (
  attribution: LaunchAttribution,
): { channel?: Channel; utmCampaignId?: string } => {
  if (attribution.channel === Channel.Utm) {
    return { channel: Channel.Utm, utmCampaignId: attribution.utmCampaignId };
  }
  return { channel: attribution.channel };
};

/**
 * A channel actually sent on an interaction, with its dispatch timestamp.
 * `channel` is dropped once an order is placed — only `at` lives on, to keep
 * the send-throttle accurate — so a post-order entry is never compared against
 * later events (which would otherwise produce a false `multi`).
 */
export interface SentAttribution {
  channel?: Channel;
  utmCampaignId?: string;
  at: string; // ISO 8601 dispatch time (device clock), same source as occurredAt
}

/** Relevance / session window. Mirrors the events send-throttle interval. */
export const EVENTS_SEND_INTERVAL = 30 * 60 * 1000;
